import styled from 'styled-components';

export const MyBookingsInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    padding-top: ${props.theme.spacing.large.l20};
  `
);

export const MyBookingsCardWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l15};
    background-color: ${props.theme.colors.white.base};
    border-radius: 6px;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
    align-items: center;
    z-index: 1;
  `
);

export const TripActiveStatusWrap = styled.div(
  props => `
    width: 5rem;
    height: 5rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    margin-right: ${props.theme.spacing.large.l15};
    background-color: ${props.isActive ? '#50e3c2' : props.theme.colors.grey.lightd0};
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
  `
);

export const TripStatusWrap = styled.div(
  props => `
    width: 5rem;
    height: 5rem;
    display: flex;
    border-radius: 44.8px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    margin-right: ${props.theme.spacing.large.l15};
    background-color: ${props.theme.colors.grey.lightf2};
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  `
)

export const TripActiveStatusText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.base};
  `
);

export const TripDateText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.base};
  `
);

export const TripMonthText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.base};
  `
);

export const TripStatusText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font18};
    color: ${props.theme.colors.grey.dark74};
    font-weight: ${props.theme.font.fontWeight.black};
    text-align: center;

    span{
        font-size:  ${props.theme.font.base};
        font-weight: normal;
        display: block;
        text-transform: ${props.theme.font.textTransform.upper};
    }
  `
);

export const TripDestInfoWrap = styled.div(
  props => `
    dispaly: flex;
    flex-direction: column;
    width:35%;
    padding:0 ${props.theme.spacing.base};
  `
);

export const TripDestInfoText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font18};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:90%;
  `
);

export const TripDestCityText = styled.span(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.dark74};
  `
);

export const TripInfoWrapper = styled.div(
  props => `
    display: flex;
    width:14%;
    flex-direction: column;
    padding-left: ${props.theme.spacing.large.l20};
  `
);

export const TripInfoHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base2};
    font-weight: ${props.theme.font.fontWeight.bold};
    text-transform: uppercase;
  `
);

export const TripInfoDateText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.black};
    padding-top: ${props.theme.spacing.small.s3};
    padding-bottom: ${props.theme.spacing.small.s2};
  `
);

export const TripInfoPaxText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
  `
);

export const TripDetailWrap = styled.div(
  props => `
    display: flex;
    width:15%;
    align-items: flex-end;
    justify-content: flex-end;
    align-self: flex-end;
    padding-bottom: ${props.theme.spacing.small.s5};
  `
);

export const TripDetailText = styled.a(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.blue.base};
    font-weight: ${props.theme.font.fontWeight.black};
    text-transform: uppercase;
    cursor: pointer;
  `
);

export const MyBookingActionsWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    background-color: ${props.theme.colors.blue.lightea};
    border-radius: 6px;
    margin-top: -${props.theme.spacing.base};
    padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.base} ${props.theme.spacing.base};
    align-items: flex-end;
    justify-content: flex-end;
  `
);

export const ActionsInnerWrap = styled.div(
  props => `
    display: flex;
    aling-items: center;
    padding-left: ${props.theme.spacing.large.l30}
  `
);

export const ActionIconWrap = styled.div(
  props => `
    width:14px;
    height: 14px;
    margin-right: ${props.theme.spacing.small.s7};
  `
);

export const ActionText = styled.a(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.blue.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    cursor: pointer;
    text-decoration: none;
    padding-top: ${props.theme.spacing.small.s5};
  `
)